var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('KeepAlive',{attrs:{"include":['HomePage', 'chat-page']}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }